/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Pit2_DInputs */

const en_viewer_pit2_d = /** @type {(inputs: Viewer_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If a payload contains the same key twice in one object, parsing keeps only the last occurrence, so the tree shows one node and gives no hint that anything was discarded. This is standard parser behaviour rather than something the viewer chooses. Search the raw text if you suspect a producer is emitting duplicates.`)
};

const ko_viewer_pit2_d = /** @type {(inputs: Viewer_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이로드의 한 객체 안에 같은 키가 두 번 있으면 파싱이 마지막 것만 남기므로, 트리에는 노드가 하나만 보이고 무엇이 버려졌는지 어떤 단서도 주지 않습니다. 뷰어의 선택이 아니라 표준적인 파서 동작입니다. 생산자가 중복을 내보내고 있다고 의심되면 원문 텍스트를 검색하세요.`)
};

const ja_viewer_pit2_d = /** @type {(inputs: Viewer_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペイロードの 1 つのオブジェクト内に同じキーが 2 回あると、パースは最後のものだけを残すので、ツリーにはノードが 1 つだけ見え、何が捨てられたかの手がかりは一切ありません。ビューアの選択ではなく標準的なパーサの挙動です。生成側が重複を出していると疑うなら、生のテキストを検索してください。`)
};

/**
* | output |
* | --- |
* | "If a payload contains the same key twice in one object, parsing keeps only the last occurrence, so the tree shows one node and gives no hint that anything wa..." |
*
* @param {Viewer_Pit2_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_pit2_d = /** @type {((inputs?: Viewer_Pit2_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Pit2_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_pit2_d(inputs)
	if (locale === "ko") return ko_viewer_pit2_d(inputs)
	return ja_viewer_pit2_d(inputs)
});